export interface TeamMember {
  id: string;
  name: string;
  phone: string;
  status: 'aktif' | 'pasif' | 'ilerliyor' | 'tamamladi';
  step1Completed: boolean;
  lastContact: string;
  note: string;
  joinDate: string;
  ownTeam?: TeamMember[];
}

export interface Settings {
  aktiflikBedeli: number;
  kayitPrimi: number;
  seviye1Kazanc: number;
  seviye2Kazanc: number;
  seviye3Kazanc: number;
  seviye4Kazanc: number;
  seviye5Kazanc: number;
  seviye6Kazanc: number;
}

export interface ActionLog {
  id: string;
  personName: string;
  action: string;
  date: string;
  type: 'message' | 'update' | 'add' | 'note';
}

export const mockSettings: Settings = {
  aktiflikBedeli: 1200,
  kayitPrimi: 200,
  seviye1Kazanc: 150,
  seviye2Kazanc: 100,
  seviye3Kazanc: 75,
  seviye4Kazanc: 50,
  seviye5Kazanc: 35,
  seviye6Kazanc: 25,
};

export const mockTeamMembers: TeamMember[] = [
  {
    id: '1',
    name: 'Ahmet Yılmaz',
    phone: '+90 532 111 2233',
    status: 'ilerliyor',
    step1Completed: false,
    lastContact: '2026-03-22',
    note: '1. adımı anlatıldı, düşünüyor.',
    joinDate: '2026-03-01',
    ownTeam: [
      { id: '1a', name: 'Kemal Arslan', phone: '+90 531 333 4455', status: 'pasif', step1Completed: false, lastContact: '2026-03-20', note: '', joinDate: '2026-03-10' },
      { id: '1b', name: 'Selin Kaya', phone: '+90 533 222 3344', status: 'aktif', step1Completed: true, lastContact: '2026-03-23', note: '', joinDate: '2026-03-12' },
    ]
  },
  {
    id: '2',
    name: 'Fatma Demir',
    phone: '+90 505 444 5566',
    status: 'aktif',
    step1Completed: true,
    lastContact: '2026-03-23',
    note: 'Harika ilerleme gösteriyor.',
    joinDate: '2026-02-15',
    ownTeam: [
      { id: '2a', name: 'Murat Şen', phone: '+90 542 555 6677', status: 'aktif', step1Completed: true, lastContact: '2026-03-24', note: '', joinDate: '2026-03-05' },
      { id: '2b', name: 'Ayşe Çelik', phone: '+90 506 777 8899', status: 'ilerliyor', step1Completed: false, lastContact: '2026-03-21', note: '', joinDate: '2026-03-08' },
      { id: '2c', name: 'Hasan Koç', phone: '+90 507 111 2345', status: 'pasif', step1Completed: false, lastContact: '2026-03-15', note: '', joinDate: '2026-03-09' },
    ]
  },
  {
    id: '3',
    name: 'Mehmet Çetin',
    phone: '+90 543 777 8899',
    status: 'tamamladi',
    step1Completed: true,
    lastContact: '2026-03-21',
    note: '2. adıma hazır.',
    joinDate: '2026-02-01',
    ownTeam: [
      { id: '3a', name: 'Zeynep Yıldız', phone: '+90 530 999 0011', status: 'aktif', step1Completed: true, lastContact: '2026-03-24', note: '', joinDate: '2026-03-02' },
      { id: '3b', name: 'Emre Güler', phone: '+90 505 123 4567', status: 'aktif', step1Completed: false, lastContact: '2026-03-22', note: '', joinDate: '2026-03-04' },
    ]
  },
  {
    id: '4',
    name: 'Zeynep Kara',
    phone: '+90 554 000 1122',
    status: 'pasif',
    step1Completed: false,
    lastContact: '2026-03-10',
    note: 'Ulaşım güç, tekrar dene.',
    joinDate: '2026-03-05',
    ownTeam: []
  },
];

export const mockActionLogs: ActionLog[] = [
  { id: '1', personName: 'Ahmet Yılmaz', action: 'WhatsApp mesajı gönderildi', date: '2026-03-22 14:35', type: 'message' },
  { id: '2', personName: 'Fatma Demir', action: 'Durum Aktif olarak güncellendi', date: '2026-03-22 11:10', type: 'update' },
  { id: '3', personName: 'Mehmet Çetin', action: '1. Adım tamamlandı olarak işaretlendi', date: '2026-03-21 16:00', type: 'update' },
  { id: '4', personName: 'Zeynep Kara', action: 'Not eklendi: Tekrar aranacak', date: '2026-03-20 09:20', type: 'note' },
  { id: '5', personName: 'Fatma Demir', action: 'Tebrik mesajı gönderildi', date: '2026-03-19 10:45', type: 'message' },
];

export const mockRiskMembers = [
  { id: '4', name: 'Zeynep Kara', risk: 'Uzun süredir iletişim yok', daysAgo: 14, phone: '+90 554 000 1122' },
  { id: '1', name: 'Ahmet Yılmaz', risk: '1. adımda sıkışmış', daysAgo: 2, phone: '+90 532 111 2233' },
];

export const whatsappTemplates = [
  {
    id: 'aktiflik',
    title: 'Aktiflik Hatırlatma',
    icon: 'ri-alarm-warning-line',
    color: 'text-yellow-400',
    message: 'Merhaba {isim}! Bu ay aktifliğini tamamlamayı unutma. Aktif kalmak, sistemin sağlıklı çalışması için çok önemli. Destek gerekirse buradayım. 💪'
  },
  {
    id: 'tebrik',
    title: 'Tebrik',
    icon: 'ri-trophy-line',
    color: 'text-green-400',
    message: 'Tebrikler {isim}! 🎉 1. adımı başarıyla tamamladın. Bu harika bir başlangıç. Sıradaki adımda da seninle birlikte ilerliyoruz!'
  },
  {
    id: 'adim1',
    title: '1. Adım Anlatım',
    icon: 'ri-footprint-line',
    color: 'text-blue-400',
    message: 'Merhaba {isim}! STEP6 sisteminde 1. adım şu anlama geliyor: Aylık ürün alımını yaparak aktifliğini koru ve ekibine 4 kişi ekle. Şu an {eksik_kisi} kişilik boşluk var. Birlikte dolduralım! 🚀'
  },
  {
    id: 'motivasyon',
    title: 'Motivasyon',
    icon: 'ri-fire-line',
    color: 'text-orange-400',
    message: 'Merhaba {isim}! Sisteme göre tahminî kazancın bu ay {tahmini_gelir}₺ olabilir. Küçük adımlar büyük sonuçlar doğurur. Devam et! 💰'
  },
  {
    id: 'adim2',
    title: '2. Adım Geçiş',
    icon: 'ri-arrow-right-circle-line',
    color: 'text-purple-400',
    message: 'Merhaba {isim}! Artık 2. adıma geçmeye hazırsın! Ekibini büyüt, kazancını katla. Seninle konuşmak istiyorum, uygun bir zamanda görüşelim. 🔥'
  },
];
